import { InjectionToken } from '@angular/core';

export const COMPANY_ACCESS_REJECTED_URL = new InjectionToken<string>(
  'company-access-rejected-url'
);
